import React from "react";
import {
  Button,
  Container,
  H2,
  H3,
  Img,
  Paragraph,
  Section,
} from "../../Styles/Global.Styled";
import { css } from "styled-components";
import { useNavigate } from "react-router-dom";

const sectionStyle = (flexD, bgColor) => css`
  flex-direction: ${flexD};
  background-color: ${({ theme }) => bgColor && theme.bgColor};
  padding: 5vh 10vw;
  gap: 5vh;
  align-items: center;
`;
const sectionStyleMb = css`
  flex-direction: column;
  padding: 5vh 5vw;
  gap: 2vh;
`;
const cntStyle = css`
  flex-direction: column;
  gap: 2vh;
  flex-grow: 1;
  padding: 1vh 0;
`;
const widthStyle = css`
  width: 100%;
`;
const imgSize = css`
  height: 35vh;
  width: 25vw;
`;
const h3Style = css`
  font-size: 1.5vh;
  color: ${({ theme }) => theme.thirdColor};
  font-family: "Playfair Display";
  margin-bottom: 3vh;
  font-style: italic;
`;
const secBttn2 = css`
  color: ${({ theme }) => theme.main};
  border: 2px solid ${({ theme }) => theme.main};
  border-radius: 25px;
  align-self: flex-start;
  padding: 0.5vh 3vh;
  margin-top: 3vh;
  font-size: 1.8vh;
`;

const SectionType1 = ({ content }) => {
  const navigate = useNavigate();
  return (
    <Section
      id={content.id}
      $baseStyle={sectionStyle(content.flexD, content.bgColor)}
      $mStyle={sectionStyleMb}
    >
      <Container $baseStyle={cntStyle} $mStyle={widthStyle}>
        <H2>{content.header}</H2>
        {content.subHeader && <H3 $baseStyle={h3Style}>{content.subHeader}</H3>}
        <Paragraph>{content.paragraph}</Paragraph>
        {content.cta && (
          <Button $baseStyle={secBttn2} onClick={() => navigate(content.url)}>
            {content.cta}
          </Button>
        )}
      </Container>
      <Img
        $baseStyle={imgSize}
        $mStyle={widthStyle}
        src={content.img}
        alt="image"
      />
    </Section>
  );
};

export default SectionType1;
